import React from "react";

import { Container } from "./shared";

import Spacer, { Axis } from "~/components/Spacer";

export default function TrustedVaspLink({ hasPadding, clickable }: { hasPadding: boolean; clickable: boolean }) {
  return (
    <Container hasPadding={hasPadding} clickable={clickable}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <img src={"/assets/trusted-vasp.svg"} />
        <Spacer axis={Axis.HORIZONTAL} size={12} />
        <div>TRUSTED LIST</div>
      </div>
    </Container>
  );
}
